module.exports = "/static/c478bf9941253bde4b4c0d09cdc171a3.png";